'use strict';

var app = require('mag-app'),
    keys = require('stb-keys'),

    ModalMessage  = require('mag-component-modal'),
    LayoutList    = require('mag-component-layout-list'),
    Panel    = require('stb-component-panel'),

    previousFocusedComponent = null,

    menu = new ModalMessage({
        title: gettext('Exit from application?'),
        visible: false,
        className: 'popup',
        children: [
            new Panel({className: 'plaintext'}),
            new LayoutList({
                className: 'padded',
                size: 1,
                focusIndex: 1,
                data: [
                    {
                        items: [
                            {
                                className: 'centeredText',
                                value: gettext('Close')
                            }
                        ],
                        click: function () {
                            window.top.platformApi.exit();
                            setTimeout(function () {
                                menu.hide();
                            }, 0);
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        if ( event.code === keys.back ) {
                            event.stop = true;
                            // widget
                            setTimeout(function () {
                                menu.hide();
                            }, 0);
                        }
                    }
                }
            })
        ],
        events: {
            show: function () {
                previousFocusedComponent = app.activePage.activeComponent;
                this.children[1].focus();
            },
            hide: function () {
                previousFocusedComponent.focus();
            }
        }
    });


menu.children[0].$body.innerText = gettext('The OK button will become active when you finish reading the End-User License Agreement');

module.exports = menu;
